const DEV_HOSTNAMES = ['localhost', 'matheus-test-dev.robotip.com.br'];

export function isDevEnv(): boolean {
    return DEV_HOSTNAMES.some(h => window.location.hostname.includes(h));
}